import { gql, useMutation } from '@apollo/client';

export const CREATE_HISTORY_ITEM = gql`
  mutation createHistoryItem(
    $type: HistoryType!
    $path: String!
    $text: String!
    $action: HistoryAction!
    $parentId: ID
    $subtype: String
  ) {
    createHistoryItem(
      type: $type
      path: $path
      text: $text
      action: $action
      parentId: $parentId
      subtype: $subtype
    ) {
      id
      parentId
      createdAt
      type
      path
      text
      subtype
    }
  }
`;

export const UPDATE_HISTORY_ITEM = gql`
  mutation updateHistoryItem(
    $id: ID!
    $parentId: ID
    $type: HistoryType!
    $path: String!
    $text: String!
    $subtype: String
  ) {
    updateHistoryItem(
      id: $id
      parentId: $parentId
      type: $type
      path: $path
      text: $text
      subtype: $subtype
    ) {
      id
      parentId
      createdAt
      type
      path
      text
      subtype
    }
  }
`;

export const GET_HISTORY_ITEMS = gql`
  query getHistoryItems($startDate: String!, $endDate: String) {
    historyItemsByDate(startDate: $startDate, endDate: $endDate) {
      id
      createdAt
      type
      path
      text
      action
      parentId
      subtype
      children {
        id
        createdAt
        type
        path
        text
        parentId
        subtype
      }
    }
  }
`;

export const GET_HISTORY_DATES = gql`
  query getHistoryDates {
    historyDates
  }
`;

export function useCreateHistory(options = {}) {
  const [fn] = useMutation(CREATE_HISTORY_ITEM, options);
  return fn;
}
export function useUpdateHistory(options = {}) {
  const [fn] = useMutation(CREATE_HISTORY_ITEM, options);
  return fn;
}

export const GET_PRACTITIONER_HISTORY = gql`
  query getPractitionerHistory {
    historyItemsByType(limit: 5, type: PRACTITIONER, action: VIEW) {
      id
      createdAt
      text
      path
    }
  }
`;
